/**
*
* Personalise toggler
*
*/
let $personaliseToggler = $('[data-personalise-toggle]')
let $personaliseTarget = $('[data-personalise]')
let $productTabsHeader = $('.product-tabs-header')
$personaliseToggler.on('click', function(e) {

    e.preventDefault()

    $('.personalise-now button').toggleClass('opacity-50 cursor-not-allowed')

    // Toggle the tabs to have a blue header
    $productTabsHeader.toggleClass('bg-slate-blue-100')

    // Show the personalise  area
    $personaliseTarget.toggleClass('hidden')

    if ($personaliseToggler.length > 0) {

        if (!$personaliseToggler.hasClass('hidden')) {
            $('.personalise-now button').removeClass('opacity-50 cursor-not-allowed')
        }

        // Scroll to it
        window.scroll({
            top: (!$personaliseToggler.hasClass('hidden')) ? $personaliseTarget.offset().top : 0,
            behavior: 'smooth'
        })

        // Fix for IE's not liking window.scroll
        if (theme.oldBrowsers.isIE11 || theme.oldBrowsers.isIE10Down) {
            $('html, body').animate({
                scrollTop: (!$personaliseToggler.hasClass('hidden')) ? $personaliseTarget.offset().top : 0,
            }, 1000);
        }

    }

})